export default __webpack_public_path__ + "static/media/foot-bg.d7325fa8.png";